import { Type } from '@angular/core';
import { FetchStudentClassesEffect } from '../../features/classes/effects/fetch-student-classes.effect';
import { ChallengeActivityRealtimeService } from '../../features/exams/effects/challenge-activity-realtime.service';
import { SyncChallengeActivityStateService } from '../../features/exams/effects/sync-challenge-activity-state.service';
import { CloseHomeworkDialogEffectService } from '../../features/homework/effects/close-homework-dialog-effect.service';
import { SyncHomeworkActivityStateService } from '../../features/homework/effects/sync-homework-activity-state.service';
import { HomeworkActivityRealtimeService } from '../../effects/homework-activity-realtime.service';
import { PracticeActivityRealtimeService } from '../../effects/practice-activity-realtime.service';
import { SyncPracticeActivityStateService } from '../../effects/sync-practice-activity-state.service';
import { UpdateUserMarksOnAttemptGradedService } from '../../effects/update-user-marks-on-attempt-graded.service';

export const SHELL_EFFECTS: Array<Type<unknown>> = [
  PracticeActivityRealtimeService,
  ChallengeActivityRealtimeService,
  HomeworkActivityRealtimeService,
  SyncPracticeActivityStateService,
  SyncChallengeActivityStateService,
  SyncHomeworkActivityStateService,
  CloseHomeworkDialogEffectService,
  UpdateUserMarksOnAttemptGradedService,
  FetchStudentClassesEffect,
];
